module.exports = __webpack_public_path__ + "static/media/oblong_light_with_pencil.8493d9bf.svg";